module.exports = {"auth.loggedin.success":"You are now logged in as","auth.loggedout.success":"You have been logged out","auth.signedup.success":"Signed up","auth.reset.initiated":"Reset initiated","auth.account.activated":"Account activated"}


//////////////////
// WEBPACK FOOTER
// ./src/app/translations/en.json
// module id = 561
// module chunks = 0